import { useState, useEffect } from 'react';
import './pages.css';
import './ProfilePage.css';

const Toggle = ({ checked, onChange }) => (
    <div onClick={onChange} style={{
        width:'44px',height:'24px',borderRadius:'12px',cursor:'pointer',
        background:checked?'#0755d9':'#cbd5e1',position:'relative',transition:'background 0.2s',flexShrink:0,
    }}>
        <div style={{
            position:'absolute',top:'3px',left:checked?'23px':'3px',
            width:'18px',height:'18px',background:'white',borderRadius:'50%',transition:'left 0.2s',
            boxShadow:'0 1px 4px rgba(0,0,0,0.2)',
        }}/>
    </div>
);



function ProfilePage() {
    const [user, setUser] = useState({ 
        name:'', email:'', phone:'', kycStatus:'', role:'', joinDate:'', 
        profilePic:null, clientId:'', address:'', dob:'', gender:'', creditScore:'', panNumber:'' 
    });
    const [editing, setEditing] = useState(false);
    const [form, setForm] = useState({});
    // const [points, setPoints] = useState(0);
    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState({ type:'', text:'' });
    const [modal, setModal] = useState(null);
    const [notifs, setNotifs] = useState({ email:true, sms:true, loanUpdates:true, paymentReminders:true, promos:false });
    const API_URL = process.env.REACT_APP_API_URL || '';

    useEffect(()=>{
        const s = JSON.parse(localStorage.getItem('userSession'));
        if (!s?.userId) return;
        fetch(`${API_URL}/api/auth/profile/${s.userId}`, {
            credentials: 'include',
            headers: s.token ? { Authorization: `Bearer ${s.token}` } : {},
        }).then(r=>r.json()).then(d=>{
            if (d.success){
                const u = {
                    name:d.user.name, email:d.user.personal_email || d.user.email, phone:d.user.phone,
                    kycStatus:d.user.kycStatus||'Pending', role:d.user.role||'User',
                    joinDate:new Date(d.user.joinDate).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric', timeZone: 'Asia/Kolkata'}),
                    // Display the saved selfie using the server-generated signed URL.
                    profilePic:d.user.profilePhotoUrl||null,
                    clientId:d.user.clientId,
                    address:d.user.address,
                    dob:d.user.dob ? new Date(d.user.dob).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' }) : null,
                    gender:d.user.gender,
                    creditScore:d.user.creditScore,
                    panNumber:d.user.panNumber,
                };
                setUser(u); setForm(u);
            }
        }).catch(()=>{});

        // Fetch reward points
        // fetch(`${API_URL}/api/dashboard/all-data/${s.userId}`)
        //     .then(r => r.json())
        //     .then(d => {
        //         if (d.success && d.gamification) {
        //             setPoints(d.gamification.pointsBalance || 0);
        //         }
        //     })
        //     .catch(()=>{});
    },[API_URL]);

    const showMsg = (type, text) => { setMsg({type,text}); setTimeout(()=>setMsg({type:'',text:''}),3500); };

    const handleSave = async (e) => {
        e.preventDefault(); setSaving(true);
        const s = JSON.parse(localStorage.getItem('userSession'));
        try {
            const r = await fetch(`${API_URL}/api/auth/profile/update/${s.userId}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
            const d = await r.json();
            if (d.success){ setUser({...user,...form}); setEditing(false); showMsg('success','Profile updated successfully!'); }
            else showMsg('error','Failed to update profile.');
        } catch { showMsg('error','Update failed.'); } finally { setSaving(false); }
    };

    const kycColor = user.kycStatus==='completed'?'#10b981':user.kycStatus==='in_progress'?'#f59e0b':'#ef4444';
    const kycLabel = user.kycStatus==='completed'?'✅ Verified':user.kycStatus==='in_progress'?'🔄 In Progress':'⏳ Pending';

    const SETTINGS = [
        { key:'notifications',icon:'🔔',label:'Notification Preferences',desc:'Control alerts and reminders' },
    ];

    return (
        <div className="pg-root pf-root">

            <section className="pf-hero">
                <div className="pf-hero-copy">
                    <span className="pf-hero-kicker"><i aria-hidden="true">✓</i>Personal Profile</span>
                    <h1>My <span>Profile</span></h1>
                    <p>Manage your personal information and preferences</p>
                </div>
                <div className="pf-hero-art" aria-hidden="true">
                    <span className="pf-art-chip pf-art-chip-1">⊞</span>
                    <span className="pf-art-card">
                        <span className="pf-art-head" />
                        <span className="pf-art-line" />
                        <span className="pf-art-line pf-art-line-short" />
                    </span>
                    <span className="pf-art-shield">✓</span>
                </div>
                <div className="pf-hero-list" aria-hidden="true">
                    <strong><i>✓</i>Your Profile</strong>
                    {['Personal Details', 'Account Settings', 'Notification Preferences', 'Secure & Private'].map(item => (
                        <span key={item}><i>✓</i>{item}</span>
                    ))}
                </div>
                <span className="pf-hero-gear" aria-hidden="true">⚙️</span>
            </section>

            {msg.text && (
                <div className={`pg-alert ${msg.type==='success'?'pg-alert-success':'pg-alert-danger'}`}>
                    <span className="pg-alert-icon">{msg.type==='success'?'✅':'⚠️'}</span>
                    <div className="pg-alert-body" style={{flex:1}}><p>{msg.text}</p></div>
                </div>
            )}

            <div className="pf-row">
                {/* Avatar Card */}
                <div className="pf-card pf-avatar-card">
                    <div className="pf-avatar-ring" aria-hidden="true" />
                    <div className="pf-avatar-wrap">
                        <div className="pf-avatar">
                            {user.profilePic ? <img src={user.profilePic} alt="Your saved selfie"/> : user.name?.charAt(0)||'?'}
                        </div>
                    </div>
                    <div className="pf-avatar-name">{user.name||'—'}</div>
                    <div className="pf-avatar-meta">Member since</div>
                    <div className="pf-avatar-date"><span aria-hidden="true">🗓️</span> {user.joinDate||'—'}</div>
                    <span className="pf-kyc" style={{background:`${kycColor}15`,color:kycColor,borderColor:`${kycColor}40`}}>
                        {kycLabel}
                    </span>
                </div>

                {/* Personal Details */}
                <div className="pf-card pf-details">
                    <div className="pf-details-head">
                        <span className="pf-head-icon" aria-hidden="true">👤</span>
                        <h2>Personal Details</h2>
                        <button className="pf-edit-btn" onClick={()=>{ setEditing(!editing); if(editing) setForm(user); }}>
                            {editing?'✕ Cancel':'✏️ Edit Details'}
                        </button>
                    </div>
                    {editing ? (
                        <form onSubmit={handleSave}>
                            <div className="pg-form">
                                <div className="pg-field-row">
                                    <div className="pg-field">
                                        <label>Full Name {user.kycStatus === 'completed' && '(Verified)'}</label>
                                        <input type="text" name="name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required disabled={user.kycStatus === 'completed'} title={user.kycStatus === 'completed' ? 'Name cannot be changed after KYC verification' : ''} style={{ opacity: user.kycStatus === 'completed' ? 0.6 : 1, cursor: user.kycStatus === 'completed' ? 'not-allowed' : 'text' }}/>
                                    </div>
                                    <div className="pg-field">
                                        <label>Email Address *</label>
                                        <input type="email" name="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required/>
                                    </div>
                                    <div className="pg-field">
                                        <label>Phone Number (Login ID)</label>
                                        <input type="tel" name="phone" value={form.phone} disabled style={{ opacity: 0.6, cursor: 'not-allowed' }} title="Phone number cannot be changed as it is your login ID."/>
                                    </div>
                                </div>
                                <div style={{display:'flex',gap:'0.75rem',justifyContent:'flex-end',marginTop:'0.25rem'}}>
                                    <button type="submit" className="pg-btn pg-btn-primary" disabled={saving}>{saving?'Saving…':'Save Changes'}</button>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <div className="pf-details-grid">
                            {[['👤','Full Name',user.name],['✉️','Email Address',user.email],['📞','Phone Number',user.phone],['🗓️','Member Since',user.joinDate]].map(([icon,l,v])=>(
                                <div className="pf-detail" key={l}>
                                    <span className="pf-detail-icon" aria-hidden="true">{icon}</span>
                                    <div className="pf-detail-text">
                                        <span className="pf-detail-label">{l}</span>
                                        <span className="pf-detail-value">{v||'—'}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Settings */}
            <div className="pf-card pf-settings">
                <div className="pf-settings-head">
                    <span className="pf-head-icon pf-head-icon-lg" aria-hidden="true">⚙️</span>
                    <div>
                        <h2>Account Settings</h2>
                        <p>Manage your preferences and account configurations</p>
                    </div>
                </div>
                {SETTINGS.map(s=>(
                    <button type="button" className="pf-setting" key={s.key} onClick={()=>setModal(s.key)}>
                        <span className="pf-setting-icon" aria-hidden="true">{s.icon}</span>
                        <span className="pf-setting-text">
                            <strong>{s.label}</strong>
                            <small>{s.desc}</small>
                        </span>
                        <span className="pf-setting-bell" aria-hidden="true">🔔</span>
                        <span className="pf-setting-arrow" aria-hidden="true">›</span>
                    </button>
                ))}
            </div>

            {/* Notifications Modal */}
            {modal==='notifications' && (
                <div className="pg-modal-overlay" onClick={()=>setModal(null)}>
                    <div className="pg-modal" onClick={e=>e.stopPropagation()}>
                        <div className="pg-modal-header"><h2>🔔 Notification Preferences</h2><button className="pg-modal-close" onClick={()=>setModal(null)}>×</button></div>
                        <div className="pg-modal-body">
                            <div style={{display:'flex',flexDirection:'column',gap:'0'}}>
                                {[['email','Email Notifications','Receive updates via email'],
                                  ['sms','SMS Notifications','Get updates via SMS'],
                                  ['loanUpdates','Loan Updates','Loan status changes'],
                                  ['paymentReminders','Payment Reminders','Upcoming EMI alerts'],
                                  ['promos','Promotional Emails','Offers and promotions'],
                                ].map(([k,label,desc])=>(
                                    <div key={k} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'0.85rem 0',borderBottom:'1px solid #dcecff'}}>
                                        <div>
                                            <div style={{fontWeight:'700',fontSize:'0.88rem',color:'#1e293b'}}>{label}</div>
                                            <div style={{fontSize:'0.75rem',color:'#94a3b8'}}>{desc}</div>
                                        </div>
                                        <Toggle checked={notifs[k]} onChange={()=>setNotifs({...notifs,[k]:!notifs[k]})}/>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="pg-modal-footer">
                            <button className="pg-btn pg-btn-ghost" onClick={()=>setModal(null)}>Cancel</button>
                            <button className="pg-btn pg-btn-primary" onClick={()=>{showMsg('success','Preferences saved!');setModal(null);}}>Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProfilePage;
